import * as React from 'react';
import * as Moment from 'moment';
import { lazyInject } from '../../../services/inversify';
import { DataService } from '../../../services/data_service';
import { ApiService } from '../../../services/api_service';
import { IDs } from '../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { generatePassword } from '../../../core/forms/helpers/generatePassword';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { formatDefaultExport } from '../../../core/table/WTableFormatter';
import { ExcelTool } from "../../../core/excel/excel_tool";
import * as XLSX from 'xlsx';

export interface SchulungRegistrierungProps {
    showDirectAddFormular?: boolean;
    onChange?: () => void;
    onClose?: () => void;
}

export interface SchulungRegistrierungState {
    loading: boolean;
}

export class SchulungRegistrierung extends React.Component<SchulungRegistrierungProps, SchulungRegistrierungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false
        };
        this.exportRegistrierungen = this.exportRegistrierungen.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ApiService) private apiService: ApiService;

    private lastDatum: number = 0;

    componentDidMount(): void {

    }

    render(): JSX.Element {
        const { onChange, onClose } = this.props;
        const berater = this.apiService.isBerater() ? this.apiService.getUserTid() : null;

        return <div>
            <WFormsTableWrapper
                theme={'tab1'}
                useTheme={1}
                containerId='unternehmen'
                entity={IDs.ENT_SCHULUNG_REGISTRIERUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                formLayout='flowV2'
                customClass={'Custom-ETA'}
                actions={['add', 'delete']}
                showColumnsHelp={true}
                columnWidths={[, , , , 180, , , , 180]}
                defaultSorted={[{ id: 'datum', desc: true }]}
                directEditFormularOf={!!this.props.showDirectAddFormular ? { tid: 0 } : null}
                customFormConfig={berater > 0 ? { berater: { hidden: true } } : null}
                preFilterServer={berater > 0 ? { berater } : null}
                formPreset={{
                    name: this.getSchulungName(),
                    anzahl: 20,
                    unternehmen: this.getSchulungName(),
                    bereich_key: 'handwerk',
                    mail: this.getSchulungMail,
                    password: generatePassword,
                    auto_delete: 1,
                    berater
                }}
                customActions={[
                    {
                        id: 'registrierungen_download',
                        label: 'Registrierungen als Excel herunterladen',
                        info: 'Registrierungen als Excel herunterladen',
                        key: 'excel',
                        func: this.exportRegistrierungen,
                    }
                ]}
                validateField={(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void) => {
                    if (key === 'datum') {
                        if (value !== this.lastDatum) {
                            const schuName = this.getSchulungName(value, data.values.name);
                            onValueChange('name', schuName, false);
                            const schuUnterName = this.getSchulungName(value, data.values.unternehmen);
                            onValueChange('unternehmen', schuUnterName, false);
                            this.lastDatum = value;
                        }
                    }
                    if (key === 'anzahl') {
                        if (value < 1) {
                            return 'Die Anzahl muss größer als 0 sein.';
                        }
                        if (value > 50) {
                            return 'Die Anzahl muss kleiner als 50 sein.';
                        }
                    }
                    return null;
                }}
                onAfterAction={(action: string, row: any) => {
                    if (!!this.props.showDirectAddFormular) {
                        if (action === 'closeForm') {
                            onClose();
                        }
                    }
                    if (action === 'saveDone' || action === 'delDone') {
                        if (typeof onChange === 'function') {
                            onChange();
                        }
                    }
                }}
                callBeforeOnFormSave={(data: any, callback: () => void) => {
                    if (data.mail) {
                        this.apiService.call('checkMailExistence', { mail: data.mail, module: IDs.MOD_ETOOL_ADMIN },
                            (res: string, suc: boolean) => {
                                // console.log(res, suc);
                                if (suc) {
                                    if (res === '1') {
                                        alert('E-Mail-Adresse existiert bereits.');
                                    } else {
                                        callback();
                                    }
                                } else {
                                    alert('Server Error');
                                }
                            }
                        );
                    }
                }}
            />
            {this.state.loading && <WSpinner />}
        </div>;
    }

    getSchulungName(stamp?: number, oldName?: string) {
        const datumStr = stamp > 0 ? Moment.unix(stamp).format('DD.MM.YYYY') : Moment().format('DD.MM.YYYY');
        if (!oldName) {
            return 'Schulung am ' + datumStr;
        } else {
            const lastDatumStr = Moment.unix(this.lastDatum).format('DD.MM.YYYY');
            return oldName.replace(lastDatumStr, datumStr);
        }
    }

    getSchulungMail() {
        const stamp2 = new Date().getTime();
        return 'schulung-' + stamp2 + '@energie-tool.de';
    }

    exportRegistrierungen(row: any) {
        this.setState({ loading: true }, () => {
            this.dataService.loadData(IDs.ENT_REGISTRIERUNG, { schulung: row.tid }, { resolve: true }, (res: any) => {
                const dataRows = (res[IDs.ENT_REGISTRIERUNG] || []).map((r: any) => {
                    return {
                        schulung: r.schulung,
                        termin: Moment.unix(row.datum).format('DD.MM.YYYY'),
                        unternehmen: r.unternehmen,
                        bereich: r.bereich_key,
                        mail: r.mail,
                        password: row.password
                    };
                });
                const filename = 'Registrierungen der Schulung am ' + Moment.unix(row.datum).format('DD.MM.YYYY');
                this.getExcel(filename, dataRows);
                this.setState({ loading: false });
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    getExcel(filename: string, dataRows: Array<any>) {
        const columns: Array<any> = [
            { accessor: 'schulung', HeaderText: 'Schulung' },
            { accessor: 'termin', HeaderText: 'Termin' },
            { accessor: 'mail', HeaderText: 'E-Mail' },
            { accessor: 'password', HeaderText: 'Passwort' },
            { accessor: 'unternehmen', HeaderText: 'Unternehmen' },
            { accessor: 'bereich', HeaderText: 'Bereich' },
        ];
        const et = new ExcelTool();
        et.dataToWb(filename, columns, dataRows, 'Export', (sheetData: XLSX.WorkSheet) => formatDefaultExport(sheetData));
    }
}
